import { render, staticRenderFns } from "./UserQuery.vue?vue&type=template&id=128ee4fb&"
import script from "./UserQuery.vue?vue&type=script&lang=js&"
export * from "./UserQuery.vue?vue&type=script&lang=js&"
import style0 from "./UserQuery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserQuery.vue"
export default component.exports